import { useMutation } from "react-query";
import axios from "axios";

export const PostClapQuery = () =>
  useMutation(
    (data) => axios.put("https://api.impactrun.com/web/v1/claps", data, {
      headers: {
        Accept: "applicatio/json",
      },
    }),
  );
